var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{key:_vm.chartKey,attrs:{"type":"pie","height":"350","options":_vm.chartOptions,"series":_vm.chartSeries}})
}
var staticRenderFns = []

export { render, staticRenderFns }